// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__YMzk6","textarea":"Textarea_textarea__0t4+x"};